import React from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ChangeToNonUseDialog from '../molecules/ChangeToNonUseDialog';

const styles = {
  button: {
    margin: '5px 5px'
  }
};

const enhance = compose(
  withState('openChangeNonUse', 'updateOpenChangeNonUse', false)
);

const button = enhance(
  ({
    classes,
    openChangeNonUse,
    updateOpenChangeNonUse,
    params,
    onClickAction,
    numberSelect,
    validMenuIdChange,
    disabled
  }) => {
    const cancelAction = () => updateOpenChangeNonUse(false);
    const changeAction = param => {
      updateOpenChangeNonUse(false);
      onClickAction(param);
    };
    return (
      <div>
        <Button
          disabled={disabled}
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={() =>
            validMenuIdChange(params.length) === 0
              ? updateOpenChangeNonUse(true)
              : null
          }
        >
          未使用にする
        </Button>
        <ChangeToNonUseDialog
          openChangeNonUse={openChangeNonUse}
          updateOpenChangeNonUse={updateOpenChangeNonUse}
          cancelAction={cancelAction}
          changeAction={() => changeAction(params)}
          numberSelect={numberSelect}
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
